import {
  Product,
  ProductReportFilters,
  ProductReportInput,
} from '@totem/components/endoflife/types';
import { Filter } from '@totem/types/common';
import { isNotNull } from '@totem/utilities/common';

export const buildFilters = (input: ProductReportInput) => {
  const paramFilters: Filter[] = [];

  if (isNotNull(input.productType) && input.productType.length > 0) {
    paramFilters.push({ field: 'productType', values: input.productType });
  }
  if (isNotNull(input.product) && input.product.length > 0) {
    paramFilters.push({ field: 'product', values: input.product });
  }
  if (isNotNull(input.name) && input.name.length > 0) {
    paramFilters.push({ field: 'name', values: input.name });
  }
  if (isNotNull(input.cycle) && input.cycle.length > 0) {
    paramFilters.push({ field: 'cycle', values: input.cycle });
  }
  if (isNotNull(input.latestVersion) && input.latestVersion.length > 0) {
    paramFilters.push({ field: 'latestVersion', values: input.latestVersion });
  }
  if (isNotNull(input.releaseDate) && input.releaseDate.length > 0) {
    paramFilters.push({ field: 'releaseDate', values: input.releaseDate });
  }
  if (isNotNull(input.endOfSupportDate) && input.endOfSupportDate.length > 0) {
    paramFilters.push({
      field: 'endOfSupportDate',
      values: input.endOfSupportDate,
    });
  }
  if (isNotNull(input.endOfLifeDate) && input.endOfLifeDate.length > 0) {
    paramFilters.push({ field: 'endOfLifeDate', values: input.endOfLifeDate });
  }
  if (isNotNull(input.discontinuedDate) && input.discontinuedDate.length > 0) {
    paramFilters.push({
      field: 'discontinuedDate',
      values: input.discontinuedDate,
    });
  }
  if (isNotNull(input.isPastEndOfSupport) && input.isPastEndOfSupport !== '') {
    paramFilters.push({
      field: 'isPastEndOfSupport',
      values: [input.isPastEndOfSupport],
    });
  }
  if (isNotNull(input.isPastEndOfLife) && input.isPastEndOfLife !== '') {
    paramFilters.push({
      field: 'isPastEndOfLife',
      values: [input.isPastEndOfLife],
    });
  }
  if (isNotNull(input.isDiscontinued) && input.isDiscontinued !== '') {
    paramFilters.push({
      field: 'isDiscontinued',
      values: [input.isDiscontinued],
    });
  }

  return paramFilters;
};

export const addFilters = (
  currentFilters: Filter[],
  input: ProductReportFilters,
) => {
  if (typeof input !== 'undefined') {
    if (isNotNull(input.productType) && input.productType.length > 0) {
      currentFilters.push({ field: 'productType', values: input.productType });
    }
    if (isNotNull(input.product) && input.product.length > 0) {
      currentFilters.push({ field: 'product', values: input.product });
    }
    if (isNotNull(input.name) && input.name.length > 0) {
      currentFilters.push({ field: 'name', values: input.name });
    }
    if (isNotNull(input.cycle) && input.cycle.length > 0) {
      currentFilters.push({ field: 'cycle', values: input.cycle });
    }
    if (isNotNull(input.latestVersion) && input.latestVersion.length > 0) {
      currentFilters.push({
        field: 'latestVersion',
        values: input.latestVersion,
      });
    }
    if (isNotNull(input.releaseDate) && input.releaseDate.length > 0) {
      currentFilters.push({ field: 'releaseDate', values: input.releaseDate });
    }
    if (
      isNotNull(input.endOfSupportDate) &&
      input.endOfSupportDate.length > 0
    ) {
      currentFilters.push({
        field: 'endOfSupportDate',
        values: input.endOfSupportDate,
      });
    }
    if (isNotNull(input.endOfLifeDate) && input.endOfLifeDate.length > 0) {
      currentFilters.push({
        field: 'endOfLifeDate',
        values: input.endOfLifeDate,
      });
    }
    if (
      isNotNull(input.discontinuedDate) &&
      input.discontinuedDate.length > 0
    ) {
      currentFilters.push({
        field: 'discontinuedDate',
        values: input.discontinuedDate,
      });
    }
    if (
      isNotNull(input.isPastEndOfSupport) &&
      input.isPastEndOfSupport !== ''
    ) {
      currentFilters.push({
        field: 'isPastEndOfSupport',
        values: [input.isPastEndOfSupport],
      });
    }
    if (isNotNull(input.isPastEndOfLife) && input.isPastEndOfLife !== '') {
      currentFilters.push({
        field: 'isPastEndOfLife',
        values: [input.isPastEndOfLife],
      });
    }
    if (isNotNull(input.isDiscontinued) && input.isDiscontinued !== '') {
      currentFilters.push({
        field: 'isDiscontinued',
        values: [input.isDiscontinued],
      });
    }
  }

  return currentFilters;
};

export const getEmptyRecord = (): Product => {
  return {
    id: '',
    productType: '',
    product: '',
    name: '',
    codeName: '',
    releaseLabel: '',
    cycle: '',
    latestVersion: '',
    releaseDate: '',
    endOfSupportDate: '',
    isPastEndOfSupport: false,
    endOfLifeDate: '',
    isPastEndOfLife: false,
    discontinuedDate: '',
    isDiscontinued: false,
    links: [],
    aliases: [],
  };
};
